export enum ResponseSource {
  Invite = "Invited",
  UhPanel = "UhPanel",
  ExternalPanel = "ExternalPanel",
}
